<template>
  <div>
    <PendingPrs/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import PendingPrs from '@/components/PendingPrs.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      PendingPrs
    }
  }
  </script>
  